/* eslint-disable react-hooks/exhaustive-deps */
import styled from 'styled-components';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLoggedInApi } from '../../../apis';

import AdminLogin from './AdminLogin/AdminLogin';
import Loader from '../../../components/Admin/Loader';
import { handleScrollToTop } from '../../../utils/handleScrollToTop';

const AdminPage = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleIsLoggedIn = async () => {
    try {
      const res = await isLoggedInApi();
      console.log(res);
      navigate('/admin/dashboard');
    } catch (error: any) {
      console.log(error.response.data.message);

      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleScrollToTop()
    handleIsLoggedIn();
  }, []);

  return (
    <>
      <title>Admin-login</title>
      <Wrapper>
        {!isLoading && <AdminLogin />}
        {!!isLoading && <Loader />}
      </Wrapper>
    </>
  );
};

export default AdminPage;

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
